import React from 'react';
import { Navigation as Navigation$1, Button, Spinner, Group as Group$1, Dialog } from '@economic/taco';
import { datadogRum } from '@datadog/browser-rum';
import { useLocation, useNavigate, useParams, useHref, matchPath, Navigate, Route, Routes } from 'react-router-dom';
import { useLingui, Trans, I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { en, da, sv, nb } from 'make-plural/plurals';
import firebase from 'firebase/app';
import 'firebase/performance';
import 'firebase/auth';
import 'firebase/firestore';
import debounce from 'lodash.debounce';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var error = function error(_error, context) {
  datadogRum.addError(_error, context);
};
var log = {
  action: datadogRum.addAction,
  error: error,
  timing: datadogRum.addTiming
};

var _excluded = ["expanded", "fixed", "path"],
  _excluded2 = ["inset"];
var Group = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var expanded = props.expanded,
    fixed = props.fixed,
    path = props.path,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var location = useLocation();
  var onClick;
  var isExpanded = expanded;
  if (path) {
    var lastLocalStorageValue = null;
    if (window.localStorage && !fixed) {
      var storageKey = "menu." + path;
      lastLocalStorageValue = window.localStorage.getItem(storageKey);
      onClick = function onClick(_, isExpanded) {
        window.localStorage.setItem(storageKey, isExpanded ? 'true' : 'false');
      };
    }
    var isActiveBaseRoute = location.pathname.indexOf(path) === 0;
    // menu expansion state logic
    // 1. expand if current path is active path
    // 2. check local storage, expand if it is set to true, close if it is set to false
    // 3. if there is no value in local storage, use the expanded prop to determine the expansion state
    isExpanded = isActiveBaseRoute || (lastLocalStorageValue === null ? expanded : lastLocalStorageValue === 'true');
  }
  var group = React.createElement(Navigation$1.Menu.Group, Object.assign({}, otherProps, {
    expanded: isExpanded,
    fixed: fixed,
    onClick: onClick,
    ref: ref
  }));
  if (path) {
    return React.createElement(Authorise, {
      path: path
    }, group);
  }
  return group;
});
var Menu = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement(Navigation$1.Menu, Object.assign({}, props, {
    ref: ref
  }));
});
Menu.Group = Group;
var Navigation = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement(Navigation$1, Object.assign({}, props, {
    id: "navigation",
    className: "w-64 z-10 flex-shrink-0 border-r-2 border-grey-light",
    ref: ref
  }));
});
Navigation.Menu = Menu;
var Content = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$inset = _ref.inset,
    inset = _ref$inset === void 0 ? true : _ref$inset,
    props = _objectWithoutPropertiesLoose(_ref, _excluded2);
  return React.createElement(ErrorBoundary, null, React.createElement("main", Object.assign({}, props, {
    className: "bg-white flex-shrink flex-grow overflow-y-auto relative " + (inset ? 'p-4' : ''),
    ref: ref
  }), props.children));
});
var Layout = function Layout(props) {
  return React.createElement("div", Object.assign({}, props, {
    className: "flex-grow flex overflow-hidden"
  }));
};
Layout.Navigation = Navigation;
Layout.Content = Content;

var UnexpectedError = function UnexpectedError() {
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  return React.createElement(Layout, null, React.createElement(Layout.Content, null, React.createElement("div", {
    className: "p-8 h-full flex flex-col items-center justify-center space-y-4"
  }, React.createElement("img", {
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAABeCAMAAADvwzHqAAABFFBMVEX///8iIiIjIyMkJCQlJSUqKiorKyssLCwuLi4vLy8wMDAyMjI5OTk7Ozs9PT1BQUFCQkJGRkZHR0dMTExOTk5QUFBSUlJTU1NUVFRVVVVWVlZXV1dYWFhZWVldXV1gYGBhYWFiYmJjY2NkZGRmZmZoaGhqampsbGxtbW1ubm5vb29zc3N2dnZ5eXmEhISFhYWGhoaIiIiJiYmLi4uMjIyNjY2YmJiampqbm5ucnJydnZ2enp6goKChoaGnp6esrKyvr6+0tLS4uLi7u7u8vLzExMTMzMzOzs7Pz8/S0tLc3Nze3t7h4eHi4uLl5eXm5ubq6urr6+vt7e3v7+/w8PDx8fHy8vL09PT19fX7+/v+/v7////BjGZ4AAAAAXRSTlMAQObYZgAAAbBJREFUeNrt2dlOwkAUgOEZQRFxAauyWVkFUVGK1YIIKLtoBali5bz/e2i8IDFF4MgMMTj/VdNz8aXL9GJKTC0U8HLLF8oZRFNegWN9tUBCJnDNjBIvcC5AdnkTPkFgid7Bst3GLkf4yULspwxgmJFKWYiVPuM157AQNmCcXRCCEIQgFoIY6PoALFnGMxANN6XuBgAgxjhCd9DPHDoAYowjFPqVAoAY44gk/SoJgBjzuQr+z4L/G8V/XYgPiCAEIYi/QDy3qqWCphVK1dYze8KoZPweOa0Wy7e35aKalj3+TMVgR3TzQUmp9uBbvaoiBfNdJkQ9JmkdGFlHk2L1mYnaTqIJY2omdmozEYNIvA0TasejgxkIMGCKDLH0BLGoxBJ/ws56y2vVQiQYb9wdH1kISNmonV1rJ7rYChYEu+5crjvOhJNS5zwI/jdKvFFYQuL/001+4yuYYXKTfeEp9C+vCClKW3u+SW2MOTe2SJ5MmQzWZDJVghDE/Iiz+N6w9eHRqHPekPorYftahyl7f8yeEnwXKmA6z+GJzQcUcX+IJyigMmU8EQBcgX9LIPuZ+ACynmoZOPGX0QAAAABJRU5ErkJggg==",
    alt: i18n._("An error occurred")
  }), React.createElement("h1", null, React.createElement(Trans, {
    id: "An error occurred"
  })), React.createElement("p", null, React.createElement(Trans, {
    id: "We're sorry - something went wrong"
  })), React.createElement(Button, {
    onClick: function onClick() {
      return window.top.location.reload();
    },
    appearance: "primary"
  }, React.createElement(Trans, {
    id: "Try reloading the page"
  })))));
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      error: undefined
    };
    return _this;
  }
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      error: error
    };
  };
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    log.error(error, errorInfo);
  };
  _proto.render = function render() {
    var _this$props$component = this.props.component,
      Component = _this$props$component === void 0 ? UnexpectedError : _this$props$component;
    if (this.state.error) {
      return React.createElement(Component, {
        error: this.state.error
      });
    }
    return this.props.children;
  };
  return ErrorBoundary;
}(React.Component);

var sendVariable = function sendVariable(data) {
  if (data === void 0) {
    data = {};
  }
  try {
    if (window.dataLayer) {
      window.dataLayer.push(data);
    } else {
      console.error("Google Tag Manager has not been initialized. You must call `TagManager.initialize('GTM-XXXXX')` in the startup phase of your application before sending any events.");
    }
  } catch (error) {
    // oh well
  }
};
var sendEvent = function sendEvent(event, data) {
  if (data === void 0) {
    data = {};
  }
  return sendVariable(_extends({
    event: event
  }, data));
};

var analytics = {
  gtm: sendEvent
};

var plurals = {
  en: en,
  da: da,
  sv: sv,
  nb: nb
};
var i18nCache = {};
function load(_x, _x2) {
  return _load.apply(this, arguments);
}
function _load() {
  _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(locale, path) {
    var language, cacheKey, messages, response, _response, error;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (path === void 0) {
              path = '';
            }
            language = locale.languageCode.substring(0, 2);
            cacheKey = path ? path + "_" + language : language;
            if (!i18nCache[cacheKey]) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", i18nCache[cacheKey]);
          case 5:
            _context.prev = 5;
            if (!(process.env.NODE_ENV === 'production')) {
              _context.next = 13;
              break;
            }
            _context.next = 9;
            return import( /* webpackIgnore: true */path + "/" + language + ".mjs");
          case 9:
            response = _context.sent;
            messages = response.messages;
            _context.next = 28;
            break;
          case 13:
            _context.next = 15;
            return fetch(path + "/" + language + ".json");
          case 15:
            _response = _context.sent;
            if (!_response.ok) {
              _context.next = 22;
              break;
            }
            _context.next = 19;
            return _response.json();
          case 19:
            messages = _context.sent;
            _context.next = 28;
            break;
          case 22:
            if (!(_response.status === 404)) {
              _context.next = 27;
              break;
            }
            log.error(new Error("Failed to load locale for '" + locale.languageCode + "', fell back to English instead."));
            return _context.abrupt("return", load(_extends({}, locale, {
              languageCode: 'en-GB'
            }), path));
          case 27:
            throw new Error("Failed to fetch " + path + "/" + language + ".json");
          case 28:
            _context.next = 39;
            break;
          case 30:
            _context.prev = 30;
            _context.t0 = _context["catch"](5);
            if (!(language !== 'en')) {
              _context.next = 37;
              break;
            }
            log.error(new Error("Failed to load locale for '" + locale.languageCode + "', fell back to English instead."));
            return _context.abrupt("return", load(_extends({}, locale, {
              languageCode: 'en-GB'
            }), path));
          case 37:
            error = _context.t0;
            return _context.abrupt("return", Promise.reject("An error occurred fetching translations - " + error.code + ": " + error.message));
          case 39:
            i18n.load(language, messages);
            i18n.loadLocaleData(language, {
              plurals: plurals[language]
            });
            i18nCache[cacheKey] = messages;
            return _context.abrupt("return", Promise.resolve());
          case 43:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 30]]);
  }));
  return _load.apply(this, arguments);
}
function init(_x3) {
  return _init.apply(this, arguments);
}
function _init() {
  _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(locale) {
    var languageCode, language;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            languageCode = locale.languageCode.substring(0, 2);
            language = !!plurals[languageCode] ? languageCode : 'en';
            i18n.load(language, {});
            i18n.loadLocaleData(language, {
              plurals: plurals[language]
            });
            i18n.activate(language);
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _init.apply(this, arguments);
}
var i18nResource = {
  i18n: i18n,
  init: init,
  load: load
};

var initEmulator = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var firestoreEmulatorHost, firebaseAuthEmulatorHost, hostParts, _hostParts;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // TODO: https://github.com/e-conomic/frontend-libraries/issues/18
            firestoreEmulatorHost = process.env.FIRESTORE_EMULATOR_HOST;
            firebaseAuthEmulatorHost = process.env.FIREBASE_AUTH_EMULATOR_HOST;
            if (!(firestoreEmulatorHost || firebaseAuthEmulatorHost)) {
              _context.next = 14;
              break;
            }
            firebase.firestore().settings({
              experimentalForceLongPolling: true
            });
            if (!firebaseAuthEmulatorHost) {
              _context.next = 9;
              break;
            }
            hostParts = firebaseAuthEmulatorHost.split(':');
            if (!(hostParts.length != 2)) {
              _context.next = 8;
              break;
            }
            throw new Error('Firebase auth emulator host - bad format');
          case 8:
            firebase.auth().useEmulator("http://" + hostParts[0] + ":" + hostParts[1] + "/");
          case 9:
            if (!firestoreEmulatorHost) {
              _context.next = 14;
              break;
            }
            _hostParts = firestoreEmulatorHost.split(':');
            if (!(_hostParts.length != 2)) {
              _context.next = 13;
              break;
            }
            throw new Error('Firestore emulator host - bad format');
          case 13:
            firebase.firestore().useEmulator(_hostParts[0], parseInt(_hostParts[1]));
          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function initEmulator() {
    return _ref.apply(this, arguments);
  };
}();
var initWithToken = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(token, identity, environment) {
    var db, agreement, agreementDocument;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return firebase.auth().signInWithCustomToken(token);
          case 2:
            if (firebase.apps.length) {
              _context2.next = 4;
              break;
            }
            throw new Error("Couldn't authenticate firestore");
          case 4:
            // ensure agreement document exists, or every subsequent query will return nothing
            db = firebase.firestore();
            _context2.next = 7;
            return db.collection('agreements').doc(String(identity.agreement.number));
          case 7:
            agreement = _context2.sent;
            _context2.next = 10;
            return agreement.get();
          case 10:
            agreementDocument = _context2.sent;
            if (agreementDocument.exists) {
              _context2.next = 16;
              break;
            }
            _context2.next = 14;
            return agreement.set({});
          case 14:
            _context2.next = 16;
            return agreement.collection('users').doc(identity.user.guid).set({});
          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function initWithToken(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var useFirestore = function useFirestore(configuration, identity, environment) {
  React.useEffect(function () {
    if (!firebase.apps.length) {
      // setup the library
      firebase.initializeApp({
        projectId: configuration.projectId,
        authDomain: configuration.authDomain,
        apiKey: configuration.apiKey,
        appId: configuration.appId
      });
      if (environment === 'staging' || environment === 'production') {
        firebase.performance();
      }
      initEmulator();
      initWithToken(configuration.initialToken, identity, environment);
    }
  }, []);
};

var init$1 = function init(_ref) {
  var containerId = _ref.containerId,
    auth = _ref.auth,
    previewEnvironment = _ref.previewEnvironment;
  var code = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'//www.googletagmanager.com/gtm.js?id='+i+dl+'&gtm_auth=" + auth + "&gtm_preview=" + previewEnvironment + "&gtm_cookies_win=x';\nf.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" + containerId + "');";
  var script = document.createElement('script');
  script.innerHTML = code;
  document.head.appendChild(script);
};
var useGoogleTagManager = function useGoogleTagManager(configuration) {
  React.useEffect(function () {
    // setup the library
    init$1(configuration);
    // send initial user data
    sendVariable(configuration.data);
  }, []);
};

var cleanDatadogEvent = function cleanDatadogEvent(event) {
  switch (event.type) {
    case 'view':
      // remove email from view url
      event.view.url = event.view.url.replace(/email=[^&]*/, 'email=REDACTED');
      break;
    case 'resource':
      if (event.resource) {
        // emailAddress is present in Eloqua
        event.resource.url = event.resource.url.replace(/email=[^&]*/, 'email=REDACTED').replace(/emailAddress=[^&]*/, 'emailAddress=REDACTED').replace(/key=[^&]*/, 'key=REDACTED').replace(/gsessionid=[^&]*/, 'gsessionid=REDACTED').replace(/X-Amz-Signature=[^&]*/, 'X-Amz-Signature=REDACTED');
      }
      break;
  }
};
var init$2 = function init(applicationId, clientToken, environment, version) {
  datadogRum.init({
    applicationId: applicationId,
    clientToken: clientToken,
    site: 'datadoghq.eu',
    service: 'e-conomic',
    env: environment,
    version: version,
    sessionSampleRate: environment === 'production' ? 50 : 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask',
    trackFrustrations: true,
    allowedTracingUrls: ['https://e-conomic.com', /https:\/\/.*\.e-conomic\.(com|ws)/],
    trackSessionAcrossSubdomains: true,
    useSecureSessionCookie: true,
    silentMultipleInit: true,
    beforeSend: function beforeSend(event) {
      if (!(environment === 'staging' || environment === 'production')) {
        return false;
      }
      cleanDatadogEvent(event);
    }
  });
};
var setUser = function setUser(identity) {
  datadogRum.setUser({
    id: identity.agreement.number + "_" + identity.user.id,
    name: identity.user.id
  });
};
var startSessionReplay = function startSessionReplay(identity) {
  if (identity.agreement.features.sessionReplay) {
    datadogRum.startSessionReplayRecording();
  }
};

var HostContext = /*#__PURE__*/React.createContext(null);
function useHostContext() {
  var context = React.useContext(HostContext);
  if (!context) {
    throw new Error('useHostContext must be used within a HostContext.Provider');
  }
  return context;
}
var HostProvider = function HostProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  // configure global integrations
  useFirestore(value.configuration.integrations.firestore, value.identity, value.environment);
  useGoogleTagManager(value.configuration.integrations.googleTagManager);
  return React.createElement(HostContext.Provider, {
    value: value
  }, children);
};
var Host = function Host(_ref2) {
  var children = _ref2.children,
    configuration = _ref2.configuration,
    environment = _ref2.environment,
    origin = _ref2.origin,
    version = _ref2.version;
  var _React$useState = React.useState(),
    context = _React$useState[0],
    setContext = _React$useState[1];
  var init = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var response, localesPath, refetch, error;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // setup monitoring before making any requests
              init$2(configuration.datadog.applicationId, configuration.datadog.clientToken, environment, version);
              _context2.prev = 1;
              _context2.next = 4;
              return configuration.fetcher();
            case 4:
              response = _context2.sent;
              // load the local for the host, we must do this here because the TacoProvider requires translations
              localesPath = (origin != null ? origin : '') + "/locales";
              i18nResource.init(response.identity.locale);
              _context2.next = 9;
              return i18nResource.load(response.identity.locale, localesPath);
            case 9:
              // set user data for monitoring now that we have it
              setUser(response.identity);
              startSessionReplay(response.identity);
              // we have to have this awkward approach to refreshing (rather than e.g. changing the react key of the HostProvider)
              // due to some misuse of refreshing the routing system in our legacy codebase
              refetch = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          return _context.abrupt("return", Promise.all([window.top.mfe_hostFetcher()].concat(window.top.mfe_applicationFetchers.map(function (fetcher) {
                            return fetcher();
                          }))));
                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return function refetch() {
                  return _ref4.apply(this, arguments);
                };
              }();
              setContext(_extends({}, response, {
                environment: environment,
                refetch: refetch,
                version: version
              }));
              _context2.next = 19;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](1);
              error = _context2.t0;
              if (!error || error.response && error.response.status === 401) {
                // the api returns the appropriate login url for redirection
                window.location.replace(error.response.data + '?returnUrl=' + encodeURIComponent(window.location.href));
              } else {
                log.error(error);
              }
            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 15]]);
    }));
    return function init() {
      return _ref3.apply(this, arguments);
    };
  }();
  React.useEffect(function () {
    init();
    if (!window.top.mfe_hostFetcher) {
      window.top.mfe_hostFetcher = init;
    }
  }, []);
  if (!context) {
    // we must return because datadog is not set up, the ErrorBoundary below requires it
    return null;
  }
  return React.createElement(I18nProvider, {
    i18n: i18nResource.i18n
  }, React.createElement(HostProvider, {
    value: context
  }, children));
};

var useCurrentLocale = function useCurrentLocale() {
  var _useHostContext = useHostContext(),
    identity = _useHostContext.identity;
  return identity == null ? void 0 : identity.locale;
};

var ApplicationContext = /*#__PURE__*/React.createContext(null);
function useApplicationContext() {
  var context = React.useContext(ApplicationContext);
  if (!context) {
    throw new Error('useApplicationContext must be used within an ApplicationProvider');
  }
  return context;
}
var ApplicationProvider = function ApplicationProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  // configure local integrations
  // none currently
  return React.createElement(ErrorBoundary, null, React.createElement(React.Suspense, {
    fallback: React.createElement(Spinner, {
      className: "w-full p-8"
    })
  }, React.createElement(ApplicationContext.Provider, {
    value: value
  }, children)));
};
var Application = function Application(_ref2) {
  var basename = _ref2.basename,
    children = _ref2.children,
    configuration = _ref2.configuration,
    origin = _ref2.origin,
    version = _ref2.version;
  var _React$useState = React.useState(),
    context = _React$useState[0],
    setContext = _React$useState[1];
  var locale = useCurrentLocale();
  var init = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var localesPath, _yield$Promise$all, response, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              localesPath = (origin != null ? origin : '') + "/locales";
              _context.prev = 1;
              _context.next = 4;
              return Promise.all([configuration(), i18nResource.load(locale, localesPath)]);
            case 4:
              _yield$Promise$all = _context.sent;
              response = _yield$Promise$all[0];
              setContext({
                basename: basename,
                configuration: response,
                version: version
              });
              _context.next = 13;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              error = _context.t0;
              log.error(error);
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function init() {
      return _ref3.apply(this, arguments);
    };
  }();
  React.useEffect(function () {
    init();
    if (!window.top.mfe_applicationFetchers) {
      window.top.mfe_applicationFetchers = [];
    }
    window.top.mfe_applicationFetchers.push(init);
  }, [locale]);
  if (!context) {
    return React.createElement(Spinner, {
      className: "w-full p-8"
    });
  }
  return React.createElement(ErrorBoundary, null, React.createElement(React.Suspense, {
    fallback: React.createElement(Spinner, {
      className: "w-full p-8"
    })
  }, React.createElement(ApplicationProvider, {
    origin: origin,
    value: context
  }, children)));
};

var _excluded$1 = ["name", "origin"];
function loadComponent(scope, module) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var container, factory, Module;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __webpack_init_sharing__('default');
          case 2:
            container = window[scope]; // or get the container somewhere else
            // Initialize the container, it may provide shared modules
            _context.next = 5;
            return container.init(__webpack_share_scopes__["default"]);
          case 5:
            _context.next = 7;
            return window[scope].get(module);
          case 7:
            factory = _context.sent;
            Module = factory();
            return _context.abrupt("return", Module);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
var useDynamicScript = function useDynamicScript(url) {
  var _React$useState = React.useState(!!remotes[url] || false),
    ready = _React$useState[0],
    setReady = _React$useState[1];
  var _React$useState2 = React.useState(false),
    failed = _React$useState2[0],
    setFailed = _React$useState2[1];
  React.useEffect(function () {
    if (!url || ready) {
      return;
    }
    if (document.head.querySelector("script[src='" + url + "]")) {
      setReady(true);
      return;
    }
    var script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;
    setReady(false);
    setFailed(false);
    script.onload = function () {
      setReady(true);
    };
    script.onerror = function () {
      setReady(false);
      setFailed(true);
    };
    document.head.appendChild(script);
  }, []);
  return {
    ready: ready,
    failed: failed
  };
};
// we must cache already loaded remotes, so that we don't trigger remounts of already mounted trees
var remotes = {};
var LazyRemote = function LazyRemote(_ref2) {
  var name = _ref2.name,
    origin = _ref2.origin,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded$1);
  var url = origin + "/remoteEntry.js";
  var _useDynamicScript = useDynamicScript(url),
    ready = _useDynamicScript.ready,
    failed = _useDynamicScript.failed;
  if (!ready) {
    return null;
  }
  if (failed) {
    throw new Error("Failed to load dynamic script: {url}");
  }
  if (!remotes[url]) {
    remotes[url] = React.lazy(loadComponent(name.replace(/[^a-zA-Z ]/g, ''), './Application'));
  }
  var Component = remotes[url];
  return React.createElement(Component, Object.assign({}, props, {
    origin: origin
  }));
};

var useApplication = function useApplication() {
  var _useApplicationContex = useApplicationContext(),
    configuration = _useApplicationContex.configuration;
  return configuration;
};

var useCurrentAgreement = function useCurrentAgreement() {
  var _useHostContext = useHostContext(),
    identity = _useHostContext.identity;
  return identity == null ? void 0 : identity.agreement;
};

var useCurrentUser = function useCurrentUser() {
  var _useHostContext = useHostContext(),
    identity = _useHostContext.identity;
  return identity == null ? void 0 : identity.user;
};

var useEnvironment = function useEnvironment() {
  var _useHostContext = useHostContext(),
    environment = _useHostContext.environment;
  return environment;
};

var useHost = function useHost() {
  var _useHostContext = useHostContext(),
    configuration = _useHostContext.configuration;
  return configuration;
};

var useHostRefetch = function useHostRefetch() {
  var _useHostContext = useHostContext(),
    refetch = _useHostContext.refetch;
  return refetch;
};

var firebirdReadyResolver = undefined;
window.firebirdTask = /*#__PURE__*/new Promise(function (resolve, _) {
  firebirdReadyResolver = resolve;
});
var LegacyFrame = function LegacyFrame(_ref) {
  var basePath = _ref.basePath;
  React.useEffect(function () {
    // provides firebird with a reliable integration point for branching
    window.top.CLIENT_INTEGRATED = true;
    window.top.addEventListener('firebird:ready', function () {
      // setup integration with firebird - this simplifies inconsistent access of the global Econ in firebird
      window.top.Econ = window.firebird.Econ;
      window.top.PopUp2 = window.firebird.PopUp2;
      // subnav isn't loaded anymore, so handle the event handlers it contained
      window.top.Econ.on('entrycounter.updatesingledaybook', function () {
        return window.top.refetch('/journals/totals/draft');
      });
      window.top.Econ.on('errorstatus.updatesent', function () {
        return window.top.refetch('/sales/invoicing/sent/errors');
      });
      if (firebirdReadyResolver) {
        firebirdReadyResolver();
      }
    });
  }, []);
  var inAppInstrumentation = '';
  if (window.location.search && window.location.search.toLowerCase().includes('inappinstrumentation')) {
    inAppInstrumentation = '?InAppInstrumentation=true';
  }
  return React.createElement("iframe", {
    name: "firebird",
    className: "border-none hidden h-full w-full absolute top-0 left-0 z-0",
    src: basePath + "/default.aspx" + inAppInstrumentation,
    title: "legacy"
  });
};

var NotFound = function NotFound() {
  var navigate = useNavigate();
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  return React.createElement(Layout, null, React.createElement(Layout.Content, null, React.createElement("div", {
    className: "p-8 h-full flex flex-col items-center justify-center space-y-4"
  }, React.createElement("img", {
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAABeCAMAAADvwzHqAAABFFBMVEX///8iIiIjIyMkJCQlJSUqKiorKyssLCwuLi4vLy8wMDAyMjI5OTk7Ozs9PT1BQUFCQkJGRkZHR0dMTExOTk5QUFBSUlJTU1NUVFRVVVVWVlZXV1dYWFhZWVldXV1gYGBhYWFiYmJjY2NkZGRmZmZoaGhqampsbGxtbW1ubm5vb29zc3N2dnZ5eXmEhISFhYWGhoaIiIiJiYmLi4uMjIyNjY2YmJiampqbm5ucnJydnZ2enp6goKChoaGnp6esrKyvr6+0tLS4uLi7u7u8vLzExMTMzMzOzs7Pz8/S0tLc3Nze3t7h4eHi4uLl5eXm5ubq6urr6+vt7e3v7+/w8PDx8fHy8vL09PT19fX7+/v+/v7////BjGZ4AAAAAXRSTlMAQObYZgAAAbBJREFUeNrt2dlOwkAUgOEZQRFxAauyWVkFUVGK1YIIKLtoBali5bz/e2i8IDFF4MgMMTj/VdNz8aXL9GJKTC0U8HLLF8oZRFNegWN9tUBCJnDNjBIvcC5AdnkTPkFgid7Bst3GLkf4yULspwxgmJFKWYiVPuM157AQNmCcXRCCEIQgFoIY6PoALFnGMxANN6XuBgAgxjhCd9DPHDoAYowjFPqVAoAY44gk/SoJgBjzuQr+z4L/G8V/XYgPiCAEIYi/QDy3qqWCphVK1dYze8KoZPweOa0Wy7e35aKalj3+TMVgR3TzQUmp9uBbvaoiBfNdJkQ9JmkdGFlHk2L1mYnaTqIJY2omdmozEYNIvA0TasejgxkIMGCKDLH0BLGoxBJ/ws56y2vVQiQYb9wdH1kISNmonV1rJ7rYChYEu+5crjvOhJNS5zwI/jdKvFFYQuL/001+4yuYYXKTfeEp9C+vCClKW3u+SW2MOTe2SJ5MmQzWZDJVghDE/Iiz+N6w9eHRqHPekPorYftahyl7f8yeEnwXKmA6z+GJzQcUcX+IJyigMmU8EQBcgX9LIPuZ+ACynmoZOPGX0QAAAABJRU5ErkJggg==",
    alt: i18n._("Page not found")
  }), React.createElement("h1", null, React.createElement(Trans, {
    id: "Page not found"
  })), React.createElement("p", null, React.createElement(Trans, {
    id: "Unfortunately we couldn't find the page you're looking for"
  })), React.createElement(Group$1, null, React.createElement(Button, {
    appearance: "primary",
    onClick: function onClick() {
      return navigate(-1);
    }
  }, React.createElement(Trans, {
    id: "Go back"
  })), React.createElement(Button, {
    appearance: "primary",
    onClick: function onClick() {
      return navigate('/');
    }
  }, React.createElement(Trans, {
    id: "Go to home"
  }))))));
};

var setFirebirdWidth = /*#__PURE__*/debounce(function () {
  var frame = window.firebird.document.querySelector('#midnav-frame');
  var navigation = window.top.document.querySelector('#navigation');
  var width = '100%';
  if (navigation) {
    var isResponsive = navigation.getAttribute('data-responsive') === 'true';
    var isHidden = navigation.getAttribute('aria-hidden') === 'true';
    if (!isResponsive && !isHidden) {
      width = "calc(100% - " + navigation.offsetWidth + "px - 2px)";
    }
  }
  if (frame) {
    frame.style.width = width;
  }
}, 100);
var replaceParameters = function replaceParameters(url, params) {
  return Object.keys(params).reduce(function (u, k) {
    return u.replace(':' + k, params[k]);
  }, url);
};
var midnavWhitelist = ['/home', '/inbox', '/market', '/journal-pro', '/webshop', '/webshop-plus', '/website'];
var refreshCurrentLegacyFrame = function refreshCurrentLegacyFrame(frame) {
  if (frame === void 0) {
    frame = 'midnav';
  }
  window.top.firebird.Econ.frames[frame].location.reload();
};
var refreshCurrentLegacyPage = function refreshCurrentLegacyPage(frame) {
  if (frame === void 0) {
    frame = 'midnav';
  }
  window.top.firebird.Econ.frames[frame].location.reload();
};
var redirectToLegacyPage = function redirectToLegacyPage(legacyUrl, frame) {
  if (frame === void 0) {
    frame = 'content';
  }
  window.top.firebird.Econ.frames[frame].location.href = legacyUrl;
};
var getLegacyUrl = function getLegacyUrl(legacyUrl, params, location) {
  var url = replaceParameters(legacyUrl, params);
  var queryString = location.search ? url.includes('?') ? location.search.replace('?', '&') : location.search : undefined;
  return url + (queryString || '');
};
// we need to track paths across mounts/unmounts because full width pages
// like journal-pro take overthe whole midnav, we need to reset it when exiting
var previousPath = '';
var FrameNavigator = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FrameNavigator, _React$Component);
  function FrameNavigator() {
    var _this;
    _this = _React$Component.apply(this, arguments) || this;
    _this.state = {
      hasNavigated: false,
      isLoading: true,
      notFound: false
    };
    _this.handleFirebirdReady = function (event) {
      if (event.detail.isGettingStartedSplashScreenAvailable) {
        _this.displayFrameForGettingStartedGuide();
      } else {
        _this.bindFrameListeners('on');
        window.firebird.Econ.require('frames').navigate('midnav', 'midnav.aspx').then(function () {
          _this.navigate();
        });
      }
    };
    _this.displayFrameForGettingStartedGuide = function () {
      _this.setState({
        isLoading: false
      });
    };
    _this.notFound = function () {
      document.querySelector('iframe[name=firebird]').style.display = 'none';
      _this.setState({
        isLoading: false,
        notFound: true
      });
    };
    _this.navigate = function () {
      var _this$props = _this.props,
        params = _this$props.params,
        legacyUrl = _this$props.legacyUrl,
        location = _this$props.location;
      var frames = window.firebird.Econ.require('frames');
      var frame = midnavWhitelist.filter(function (x) {
        return location.pathname.startsWith(x);
      }).length > 0 ? 'midnav' : 'content';
      if (frames.inMidnav('content')) {
        frames.setRightFrames(true);
      }
      frames.navigate(frame, getLegacyUrl(legacyUrl, params, location));
      previousPath = location.pathname;
      _this.setState({
        hasNavigated: true
      });
      setFirebirdWidth();
    };
    _this.bindFrameListeners = function (action) {
      window.top.Econ[action]('frame.load.midnav', _this.handleMidnavReady);
      window.top.Econ[action]('frame.load.content', _this.handleContentReady);
      window.top.Econ[action]('frame.load.applet', _this.handleAppletReady);
    };
    _this.handleMidnavReady = function () {
      var applet = window.firebird.midnav.document.querySelector('iframe[name=applet]');
      var content = window.firebird.midnav.document.querySelector('iframe[name=content]');
      if (!applet && !content) {
        _this.setRouteAsReady();
        if (_this.props.onNavigated) {
          _this.props.onNavigated('midnav');
        }
      }
    };
    _this.handleContentReady = function () {
      var _this$props2 = _this.props,
        params = _this$props2.params,
        legacyUrl = _this$props2.legacyUrl,
        location = _this$props2.location;
      var url = getLegacyUrl(legacyUrl, params, location);
      // tomform pages load in the applet frame
      if (_this.state.hasNavigated && !url.includes('tomform.asp')) {
        _this.setRouteAsReady();
        if (_this.props.onNavigated) {
          _this.props.onNavigated('content');
        }
      }
    };
    _this.handleAppletReady = function () {
      if (_this.state.hasNavigated) {
        _this.setRouteAsReady();
      }
    };
    // this occurs when midnav and/or applet frames are 'ready'
    _this.setRouteAsReady = function () {
      _this.setState({
        isLoading: false
      });
    };
    return _this;
  }
  var _proto = FrameNavigator.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    if (!window.top.Econ) {
      window.top.addEventListener('firebird:ready', this.handleFirebirdReady);
    } else {
      this.bindFrameListeners('on');
      if (midnavWhitelist.filter(function (x) {
        return previousPath.startsWith(x);
      }).length > 0) {
        window.firebird.Econ.require('frames').navigate('midnav', 'midnav.aspx').then(function () {
          _this2.navigate();
        });
      } else {
        this.navigate();
      }
    }
    window.top.addEventListener('resize', setFirebirdWidth);
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var changedUrl = this.props.location.pathname !== nextProps.location.pathname;
    var reloadedCurrentUrl = !changedUrl && this.props.location.key !== nextProps.location.key;
    var changedHash = this.props.location.hash !== nextProps.location.hash;
    if (changedUrl || reloadedCurrentUrl && !changedHash || this.state.isLoading !== nextState.isLoading || this.state.notFound !== nextState.notFound) {
      document.querySelector('iframe[name=firebird]').style.display = 'none';
      return true;
    }
    return false;
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (window.top.Econ) {
      if (this.props.location.key !== prevProps.location.key && (this.props.legacyUrl !== prevProps.legacyUrl || this.props.location.hash === '')) {
        this.setState({
          hasNavigated: false,
          isLoading: true
        }, this.navigate);
      }
    }
    if (this.state.notFound) {
      document.querySelector('iframe[name=firebird]').style.display = 'none';
    } else if (prevState.isLoading && !this.state.isLoading) {
      document.querySelector('iframe[name=firebird]').style.display = 'block';
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.querySelector('iframe[name=firebird]').style.display = 'none';
    window.top.removeEventListener('resize', setFirebirdWidth);
    window.top.removeEventListener('firebird:ready', this.handleFirebirdReady);
    if (window.top.Econ) {
      this.bindFrameListeners('off');
    }
  };
  _proto.render = function render() {
    if (this.state.isLoading) {
      return React.createElement(Spinner, {
        className: "w-full p-8"
      });
    } else if (this.state.notFound) {
      return React.createElement(NotFound, null);
    }
    return null;
  };
  return FrameNavigator;
}(React.Component);
var LegacyFrameNavigator = function LegacyFrameNavigator(props) {
  var location = useLocation();
  var params = useParams();
  return React.createElement(FrameNavigator, Object.assign({}, props, {
    location: location,
    params: params
  }));
};

function useLegacyFrame() {
  var _React$useState = React.useState(false),
    show = _React$useState[0],
    setShow = _React$useState[1];
  React.useEffect(function () {
    var mounted = true;
    window.top.firebirdTask.then(function () {
      if (mounted) {
        setShow(true);
      }
    });
    return function () {
      mounted = false;
    };
  }, []);
  return {
    show: show
  };
}

var currentRouteParts = [];
var currentPathname = '';
var createRoutePath = function createRoutePath(basename) {
  return '/' + (basename ? currentRouteParts.filter(function (part) {
    return part !== basename;
  }) : currentRouteParts).join('/');
};
var useAbsolutePath = function useAbsolutePath(path) {
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useApplicationContex = useApplicationContext(),
    basename = _useApplicationContex.basename;
  if (currentPathname !== pathname) {
    // each pathname is built from separate route segments, so we only want to
    // reset currentRouteParts when the whole path changes not for each segment
    currentPathname = pathname;
    currentRouteParts = [];
  }
  var sanitizedPath = path.replace('/*', '');
  // some routes repeat the same word, we need to support them - e.g. projects/responsibility/projects
  var occurencesInPathname = pathname.split('/').filter(function (segment) {
    return segment === sanitizedPath;
  }).length;
  var occurencesInParts = currentRouteParts.filter(function (x) {
    return x === sanitizedPath;
  }).length;
  var isPartsSynced = !(occurencesInPathname > 0 && occurencesInParts < occurencesInPathname);
  if (sanitizedPath !== '/' && (!isPartsSynced || !currentRouteParts.includes(sanitizedPath))) {
    currentRouteParts.push(sanitizedPath);
  }
  var routePath = createRoutePath(basename);
  // trailing slashes break stuff, remove them
  return routePath.length > 1 && routePath.endsWith('/') ? routePath.replace(/\/+$/, '') : routePath;
};
var usePathAuthorisation = function usePathAuthorisation(path) {
  var _useApplicationContex2 = useApplicationContext(),
    configuration = _useApplicationContex2.configuration;
  var currentRoute = useAbsolutePath(path);
  var authorised = configuration.routes.hasOwnProperty(currentRoute);
  var legacyUrl = authorised ? configuration.routes[currentRoute] : null;
  return [authorised, currentRoute, legacyUrl];
};

var _excluded$2 = ["aria-label", "caseSensitive", "element", "path"];
var AuthDialogRoute = function AuthDialogRoute(props) {
  var ariaLabel = props['aria-label'],
    element = props.element,
    path = props.path,
    dialogProps = _objectWithoutPropertiesLoose(props, _excluded$2);
  var _usePathAuthorisation = usePathAuthorisation(path),
    authorised = _usePathAuthorisation[0];
  var navigate = useNavigate();
  var output;
  if (authorised) {
    output = element;
  } else {
    // in reality an unauthorised dialog should rarely be hit, because buttons etc triggering them would
    // themselves be authorised, but this handles cases where unauthorised dialog routes do get loaded
    output = React.createElement(NotFound, null);
  }
  return React.createElement(Dialog, Object.assign({}, dialogProps, {
    onClose: function onClose() {
      return navigate(-1);
    },
    defaultOpen: true
  }), React.createElement(Dialog.Content, {
    "aria-label": ariaLabel
  }, React.createElement(React.Suspense, {
    fallback: React.createElement(Spinner, {
      className: "w-full p-4"
    })
  }, React.createElement(ErrorBoundary, null, output))));
};

var useRouteAuthorisation = function useRouteAuthorisation(route) {
  var _useApplicationContex = useApplicationContext(),
    configuration = _useApplicationContex.configuration;
  var authorised = configuration.routes.hasOwnProperty(route);
  var legacyUrl = authorised ? configuration.routes[route] : null;
  return [authorised, legacyUrl];
};

var _excluded$3 = ["path"];
// support relative paths
var AuthorisePath = function AuthorisePath(props) {
  var path = props.path,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$3);
  var route = useHref(path);
  return React.createElement(AuthoriseRoute, Object.assign({}, otherProps, {
    path: route
  }));
};
// support absolute paths
var AuthoriseRoute = function AuthoriseRoute(props) {
  var children = props.children,
    path = props.path;
  var _useRouteAuthorisatio = useRouteAuthorisation(path),
    authorised = _useRouteAuthorisatio[0];
  if (authorised) {
    return children;
  }
  return null;
};
var Authorise = function Authorise(props) {
  if (props.path.startsWith('/')) {
    return React.createElement(AuthoriseRoute, Object.assign({}, props));
  }
  return React.createElement(AuthorisePath, Object.assign({}, props));
};

var _excluded$4 = ["to"],
  _excluded2$1 = ["active", "as", "onClick", "path", "state", "target", "to"];
function isModifiedEvent(event) {
  return event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
}
// support relative paths
var AuthorisedLinkByPath = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _otherProps$path;
  var to = props.to,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$4);
  var href = useHref(to);
  var route = useHref(((_otherProps$path = otherProps.path) != null ? _otherProps$path : to).split('?')[0]); // remove query strings, the route list doesn't contain them
  var _useRouteAuthorisatio = useRouteAuthorisation(route),
    authorised = _useRouteAuthorisatio[0];
  if (!authorised) {
    return null;
  }
  return React.createElement(AuthorisedLinkByRoute, Object.assign({}, otherProps, {
    to: href,
    ref: ref
  }));
});
// support absolute paths
var AuthorisedLinkByRoute = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var active = props.active,
    _props$as = props.as,
    Component = _props$as === void 0 ? 'a' : _props$as,
    onClick = props.onClick,
    path = props.path,
    state = props.state,
    target = props.target,
    to = props.to,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded2$1);
  var href = useHref(to);
  var navigate = useNavigate();
  var route = useHref((path != null ? path : to).split('?')[0]); // remove query strings, the route list doesn't contain them
  var _useRouteAuthorisatio2 = useRouteAuthorisation(route),
    authorised = _useRouteAuthorisatio2[0];
  var location = useLocation();
  var _useApplicationContex = useApplicationContext(),
    configuration = _useApplicationContex.configuration;
  if (!authorised) {
    return null;
  }
  if (to.toString().startsWith('http')) {
    return React.createElement(Component, Object.assign({}, otherProps, {
      href: to.toString(),
      onClick: onClick,
      ref: ref,
      rel: "noopener noreferrer",
      target: target
    }));
  }
  var isExactRoute = !!matchPath({
    path: href
  }, location.pathname + location.search);
  var isOneRoute = Object.keys(configuration.routes).filter(function (route) {
    return route.startsWith(href);
  }).length === 1;
  var isActive = active != null ? active : isExactRoute || location.pathname.startsWith(href) && isOneRoute;
  var handleClick = function handleClick(event) {
    if (onClick) {
      event.persist();
      onClick(event);
    }
    if (!event.defaultPrevented &&
    // onClick prevented default
    event.button === 0 && (
    // Ignore everything but left clicks
    !target || target === '_self') &&
    // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ) {
      event.preventDefault();
      navigate(to, {
        state: state
      });
    }
  };
  return React.createElement(Component, Object.assign({}, otherProps, {
    active: Component !== 'a' ? !!isActive : undefined,
    href: href,
    onClick: handleClick,
    ref: ref,
    target: target
  }));
});
var AuthorisedLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  if (props.to.startsWith('/') || props.to.startsWith('http')) {
    return React.createElement(AuthorisedLinkByRoute, Object.assign({}, props, {
      ref: ref
    }));
  }
  return React.createElement(AuthorisedLinkByPath, Object.assign({}, props, {
    ref: ref
  }));
});

var AuthorisedNavigate = function AuthorisedNavigate(props) {
  var state = props.state,
    to = props.to,
    toFirstAuthorisedSubRoute = props.toFirstAuthorisedSubRoute;
  var _useApplicationContex = useApplicationContext(),
    configuration = _useApplicationContex.configuration;
  var location = useLocation();
  var route = configuration.routes[location.pathname];
  if (route != null && route.startsWith('/')) {
    return React.createElement(Navigate, {
      to: route,
      state: state
    });
  }
  if (toFirstAuthorisedSubRoute) {
    var firstAuthorisedSubRoute = Object.keys(configuration.routes).find(function (route) {
      return route.startsWith(location.pathname) && route !== location.pathname;
    });
    if (firstAuthorisedSubRoute) {
      return React.createElement(Navigate, {
        to: firstAuthorisedSubRoute,
        state: state
      });
    }
    return React.createElement(NotFound, null);
  }
  if (to) {
    return React.createElement(Navigate, {
      to: to,
      state: state
    });
  }
  return null;
};

var _excluded$5 = ["onNavigated"];
/**
 * @deprecated use AuthRoute
 * @param props
 * @constructor
 */
var AuthorisedRoute = function AuthorisedRoute(props) {
  var onNavigated = props.onNavigated,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$5);
  var _usePathAuthorisation = usePathAuthorisation(props.path),
    authorised = _usePathAuthorisation[0],
    legacyUrl = _usePathAuthorisation[2];
  var output = null;
  if (authorised) {
    if (otherProps.element || otherProps.children) {
      output = React.createElement(Route, Object.assign({}, otherProps));
    } else {
      if (legacyUrl) {
        output = React.createElement(AuthorisedRoute, Object.assign({}, otherProps, {
          element: React.createElement(LegacyFrameNavigator, {
            onNavigated: onNavigated,
            legacyUrl: legacyUrl
          })
        }));
      } else {
        console.error(otherProps.path + " does not have an accompanying legacy url defined, nor does it have a route element.");
      }
    }
  } else {
    output = React.createElement(NotFound, null); // currently renders into Outlet, probably needs to redirect
  }

  return React.createElement(React.Suspense, {
    fallback: React.createElement(Spinner, {
      className: "w-full p-4"
    })
  }, React.createElement(ErrorBoundary, null, output));
};

var _excluded$6 = ["onNavigated"];
var AuthRoute = function AuthRoute(props) {
  var onNavigated = props.onNavigated,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$6);
  var _usePathAuthorisation = usePathAuthorisation(props.path),
    authorised = _usePathAuthorisation[0],
    legacyUrl = _usePathAuthorisation[2];
  if (!authorised) return React.createElement(NotFound, null);
  if (otherProps.element || otherProps.children) {
    return React.createElement(React.Suspense, {
      fallback: React.createElement(Spinner, {
        className: "w-full p-4"
      })
    }, React.createElement(ErrorBoundary, null, otherProps.element || otherProps.children));
  }
  if (!legacyUrl) {
    console.error(otherProps.path + " does not have an accompanying legacy url defined, nor does it have a route element.");
    return null;
  }
  return React.createElement(AuthRoute, Object.assign({}, otherProps, {
    element: React.createElement(LegacyFrameNavigator, {
      onNavigated: onNavigated,
      legacyUrl: legacyUrl
    })
  }));
};

var _excluded$7 = ["aria-label", "caseSensitive", "element", "path"];
/**
 *
 * @deprecated use AuthDialogRoute
 */
var AuthorisedDialogRoute = function AuthorisedDialogRoute(props) {
  var ariaLabel = props['aria-label'],
    caseSensitive = props.caseSensitive,
    element = props.element,
    path = props.path,
    dialogProps = _objectWithoutPropertiesLoose(props, _excluded$7);
  var _usePathAuthorisation = usePathAuthorisation(path),
    authorised = _usePathAuthorisation[0];
  var navigate = useNavigate();
  var output;
  if (authorised) {
    output = React.createElement(Route, {
      caseSensitive: caseSensitive,
      element: element,
      path: path
    });
  } else {
    // in reality an unauthorised dialog should rarely be hit, because buttons etc triggering them would
    // themselves be authorised, but this handles cases where unauthorised dialog routes do get loaded
    output = React.createElement(NotFound, null);
  }
  return React.createElement(Dialog, Object.assign({}, dialogProps, {
    onClose: function onClose() {
      return navigate(-1);
    },
    defaultOpen: true
  }), React.createElement(Dialog.Content, {
    "aria-label": ariaLabel
  }, React.createElement(React.Suspense, {
    fallback: React.createElement(Spinner, {
      className: "w-full p-4"
    })
  }, React.createElement(ErrorBoundary, null, output))));
};

var _excluded$8 = ["element", "children"],
  _excluded2$2 = ["element", "children"];
var processChild = function processChild(child) {
  if (child.type === AuthorisedRoute || child.type === AuthRoute) {
    var _child$props = child.props,
      element = _child$props.element,
      children = _child$props.children,
      rest = _objectWithoutPropertiesLoose(_child$props, _excluded$8);
    return React.createElement(Route, Object.assign({
      key: child.props.path
    }, rest, {
      element: React.createElement(AuthRoute, Object.assign({}, rest), element || children)
    }));
  }
  if (child.type === AuthorisedDialogRoute || child.type === AuthDialogRoute) {
    var _child$props2 = child.props,
      _element = _child$props2.element,
      _children = _child$props2.children,
      _rest = _objectWithoutPropertiesLoose(_child$props2, _excluded2$2);
    return React.createElement(Route, Object.assign({
      key: child.props.path
    }, _rest, {
      element: React.createElement(AuthDialogRoute, Object.assign({}, _rest), _element || _children)
    }));
  }
  // if routes are wrapped in Fragment
  if (child.type === React.Fragment) {
    return React.Children.toArray(child.props.children).filter(function (child) {
      return !!child;
    }) // remove falsey children
    .map(processChild);
  }
  return child;
};
var AuthRoutes = function AuthRoutes(_ref) {
  var children = _ref.children;
  return React.createElement(Routes, null, React.Children.toArray(children).filter(function (child) {
    return !!child;
  }) // remove falsey children
  .map(processChild));
};

var useLocalStorage = function useLocalStorage(key, initialValue) {
  var _React$useState = React.useState(function () {
      try {
        var localStorageValue = localStorage.getItem(key);
        if (typeof localStorageValue !== 'string') {
          localStorage.setItem(key, JSON.stringify(initialValue));
          return initialValue;
        } else {
          return JSON.parse(localStorageValue || 'null');
        }
      } catch (_unused) {
        // If user is in private mode or has storage restriction
        // localStorage can throw. JSON.parse and JSON.stringify
        // can throw, too.
        return initialValue;
      }
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  React.useEffect(function () {
    try {
      var serializedState = JSON.stringify(state);
      localStorage.setItem(key, serializedState);
    } catch (_unused2) {
      // If user is in private mode or has storage restriction
      // localStorage can throw. Also JSON.stringify can throw.
    }
  }, [key, state]);
  var clear = function clear() {
    return localStorage.removeItem(key);
  };
  return [state, setState, clear];
};

var Plan;
(function (Plan) {
  Plan[Plan["Internal"] = 0] = "Internal";
  Plan[Plan["StartUp"] = 1] = "StartUp";
  Plan[Plan["SmallBusiness"] = 2] = "SmallBusiness";
  Plan[Plan["Pro"] = 3] = "Pro";
  Plan[Plan["PartnerBundle"] = 4] = "PartnerBundle";
  Plan[Plan["ExternalArchive"] = 5] = "ExternalArchive";
  Plan[Plan["CurrentNonDK"] = 6] = "CurrentNonDK";
  Plan[Plan["Basis"] = 7] = "Basis";
  Plan[Plan["Plus"] = 8] = "Plus";
  Plan[Plan["Smart"] = 9] = "Smart";
  Plan[Plan["Advanced"] = 10] = "Advanced";
  Plan[Plan["Legacy"] = 11] = "Legacy";
  Plan[Plan["Unknown"] = 12] = "Unknown";
})(Plan || (Plan = {}));

export { Application, ApplicationContext, AuthDialogRoute, AuthRoute, AuthRoutes, Authorise, AuthorisedDialogRoute, AuthorisedLink, AuthorisedNavigate, AuthorisedRoute, ErrorBoundary, Host, HostContext, Layout, LazyRemote, LegacyFrame, LegacyFrameNavigator, NotFound, Plan, UnexpectedError, analytics, log, redirectToLegacyPage, refreshCurrentLegacyFrame, refreshCurrentLegacyPage, useApplication, useApplicationContext, useCurrentAgreement, useCurrentLocale, useCurrentUser, useEnvironment, useHost, useHostContext, useHostRefetch, useLegacyFrame, useLocalStorage, usePathAuthorisation, useRouteAuthorisation };
//# sourceMappingURL=react-app.esm.js.map
